import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-new-carrier-rates-option',
  templateUrl: './new-carrier-rates-option.component.html',
  styleUrls: ['./new-carrier-rates-option.component.css']
})
export class NewCarrierRatesOptionComponent implements OnInit {

  @Input() option;
  @Input() control;

  constructor() {
  }

  ngOnInit() {
    if (this.hasRequiredField(this.control) && this.option.options?.length === 1) {
      (this.control as FormControl).disable({ emitEvent: false });
    } else {
      (this.control as FormControl).enable({ emitEvent: false });
    }
  }

  hasRequiredField(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({}as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }
}
